module.exports = __webpack_public_path__ + "static/img/abc-capital-map.0a40c05.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/gotoContent/abc-capital-map.jpg
// module id = OBKq
// module chunks = 0